<template>
    <el-card class="lesson-resources-curricula" shadow="never">
        <el-tabs v-model="activeName">
            <el-tab-pane label="按时间" name="first"></el-tab-pane>
            <el-tab-pane label="按课程" name="second"></el-tab-pane>
        </el-tabs>
        <div class="curricula">
            <el-row class="curricula-item" v-for="item in pageSize" :key="item">
                <el-col :span="21">
                    <el-row class="curricula-body">
                        <el-col class="curricula-img" :span="4">
                            <a>
                                <img src="https://www.ketangpai.com/Public/Common/img/fileicon/file_ext_big_docx.png">
                            </a>
                        </el-col>
                        <el-col :span="20">
                            <h3 class="title">编程</h3>
                            <p class="learned">第1章 支持多种作业格式的在线预览及批注.docx</p>
                            <p class="date">
                                <time>发布于&nbsp;19/04/25&nbsp;&nbsp;&nbsp;09:03</time>
                            </p>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col class="curricula-action" :span="3">
                    <p class="dropdown">
                        <el-dropdown trigger="click">
                            <span class="el-dropdown-link">
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </p>
                    <p>
                        <el-button type="primary" plain>主要按钮</el-button>
                    </p>
                </el-col>
            </el-row>
            <div class="pagination">
                <el-pagination 
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            :pager-count="pagerCount"
                            :total="totalEnclosure"
                            @size-change="sizeChange"
                            @current-change="currentChange">
                </el-pagination>
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    data () {
        return {
            activeName: 'first',
            currentPage: 1, // 当前页数，支持 .sync 修饰符
            pageSize: 10, // 每页显示条目个数，支持 .sync 修饰符
            pagerCount: 7, // 页码按钮的数量，当总页数超过该值时会折叠(大于等于 5 且小于等于 21 的奇数)
            totalEnclosure: 100, // 总条目数
        }
    },
    methods: {
        // pageSize 改变时会触发
        sizeChange (pageSize) {
            this.pageSize = pageSize
        },
        // currentPage 改变时会触发
        currentChange (currentPage) {
            this.currentPage = currentPage
        }
    }
}
</script>

<style lang="less">
.lesson-resources-curricula {
    .el-tabs {
        &__nav-wrap {
            &::after {
                height: 0;
            }
        }
    }
}
</style>

<style lang="less" scoped>
.lesson-resources-curricula {
    .curricula {
        margin-top: 30px;
        .pagination {
            text-align: center;
            margin-top: 20px;
        }
        &-item {
            border-bottom: 1px solid #d0d6d9;
            padding-bottom: 20px;
            margin-bottom: 20px;
            &:nth-last-child(2) {
                border-bottom: none;
                padding-bottom: 0;
                margin-bottom: 0;
            }
        }
        &-body {
            color: #333;
            .title {
                font-weight: normal;
                font-size: 20px;
                line-height: 1.5em;
                overflow: hidden;
            }
            .learned {
                font-size: 14px;
                line-height: 2em;
            }
            .date {
                font-size: 14px;
                line-height: 2.5em;
                color: #999;
            }
        }
        &-img {
            padding-right: 3%;
            a {
                height: 93px;
                line-height: 93px;
                display: block;
                text-align: center;
                img {
                    max-width: 100%;
                    max-height: 100%;
                    vertical-align: middle;
                }
            }
        }
        &-action {
            text-align: right;
            .dropdown {
                margin-bottom: 15px;
                margin-right: 20%;
            }
        }
    }
}
</style>
